import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react'
import { downloadFile, renderHeaderActionButtons, FilterProp, useAppDispatch, useAppSelector, SidePopover, FilterLayout, TableDashboard, CustomTooltipWithLabel } from '../../../globalUtils/globalExports'
import { Menu, MenuItem } from '@mui/material';
import './ManageDeploymentLogsDashboard.css'
import { versionReleasesTypes, getCurrentScreenAppliedFiltersCount, getFilterReducer, getFilterSelectedValue, getReferenceDataReducer, getVersionReleasesReducer, setFilterData, fetchDeploymentLogsListData, setDeploymentLogsTableProps, setRedirectedStateForDeploymentLogsFilters } from '../../../rmsReduxStore/reduxExports';
import { cloneDeep } from 'lodash';
import { getCurrentFiltersValues, exportVersionReleaseListData } from '../../../rmsReduxStore/reduxExports';
import { Id, toast } from 'react-toastify';
import {  formatRelativeTimeForTable } from '../../../globalUtils/globalHooks'
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { IconWithTooltip } from '../../../globalUtils/globalIcons';


function ManageDeploymentLogsDashboard() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { deploymentLogs, deploymentLogsCount, deploymentLogTableProps, deploymentLogTableListLoader, deploymentLogsFiltersAppliedFromRedirection } = useAppSelector(getVersionReleasesReducer);
    const [exportAnchorEl, setExportAnchorEl] = useState(null)
    const { screenFilters } = useAppSelector(getFilterReducer)
    const [exportingFile, setExportingFile] = useState(false);
    const deploymentLogTablePropsRef = useRef(deploymentLogTableProps);
    const [filtersVisible, setFiltersVisible] = useState(false);
    const { chargerProductTypeReferenceData, chargingStationReferenceData,softwareVersionReferenceData,versionReleasesSwTypeReferenceData } = useAppSelector(getReferenceDataReducer)
    const deploymentLogsRef = useRef(deploymentLogs)
    const statusReferenceData = ['Failed','Success','InProgress','Scheduled'].map(item=>{
        if(item === 'InProgress'){
            return {id:item,name:'Pending',value:item,label:'Pending'}
        }
        else return {id:item,name:item,value:item,label:item}
    })

    const handleNullValuesForFields = (value : string)=> {
        if(!value)return '-';
        else return value;
    }

    const handleChargerClick = (rowData)=>{
        navigate('/charger?chargerId=' + rowData?.chargerName , {
            state:{
                 chargerId: rowData?.chargerId,
            }
        })
    }

    const deploymentLogsTableColumns = [
        {
            field: 'chargerName',
            headerName: 'Charger',
            flex: 1,
            sortable: true,
            minWidth: 150,
            renderCell: (params) => (
                <span
                    style={{
                        color: 'var(--secondary-blue-color)',
                        fontWeight: 500,
                        cursor:'pointer'
                    }}
                    onClick={()=>handleChargerClick(params.row)}
                >
                    {handleNullValuesForFields(params.value)}
                </span>
            )
        },
        {
            field: 'softwareVersion',
            headerName: 'Software Version',
            flex: 1,
            minWidth: 120,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'productType',
            headerName: 'Product Type',
            minWidth: 150,
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'swType',
            headerName: 'SW Type',
            minWidth: 100,
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'model',
            headerName: 'Model',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'stationName',
            headerName: 'Charging Station',
            minWidth: 250,
            flex: 1,
            sortable: true,
            renderCell: (params) => {
                const rowData = params.row
                return  (
                    <CustomTooltipWithLabel label={rowData?.stationName} labelId={rowData?.id} />
                )
            }
        },
        {
            field: 'city',
            headerName: 'City (Location)',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'customer',
            headerName: 'Customer',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 120,
            sortable: true,
            renderCell: (params) => {
                let color = ''
                let backgroundColor = ''
                let btnIconClassName = ''
                let text = params.value
                switch (params.value) {
                    case 'Failed':
                        backgroundColor = '#F64848';
                        color = '#FFFFFF';
                        btnIconClassName = 'rms__version__release__deployment__failure__icon'
                        break;

                    case 'Success':
                        backgroundColor = '#2BB474';
                        color = '#FFFFFF';
                        btnIconClassName = 'rms__version__release__deployment__success__icon'
                        break;

                    case 'InProgress':
                        backgroundColor = '#DBA02A';
                        color = '#FFFFFF';
                        btnIconClassName = 'rms__version__release__deployment__pending__icon'
                        text = 'Pending'
                        break;

                    case 'Scheduled':
                        backgroundColor = '#2282E2';
                        color = '#FFFFFF';
                        btnIconClassName = 'rms__version__release__deployment__scheduled__icon'
                        break;
                }


                return <div
                    style={{
                        backgroundColor: backgroundColor,
                        color: color,
                        padding: '6px 10px',
                        fontSize: '12px',
                        fontWeight: 500,
                        borderRadius: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                    }}
                >
                    <div className={'rms__icon ' + btnIconClassName}></div>
                    <div>{text}</div>
                </div>

            }
        },
        {
            field: 'setBy',
            headerName: 'Set By',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{handleNullValuesForFields(params.value)}</span>
            )
        },
        {
            field: 'source',
            headerName: 'Source',
            flex: 1,
            minWidth: 100,
            sortable: true,
            renderCell: (params) => {
                if(params?.value && params.value.toLowerCase() === 'software version release'){
                    return <IconWithTooltip iconClassName={'version__releases__deployment__log__source__software__release-icon'} toolTipText={params.value}/>
                }else {
                    return <IconWithTooltip iconClassName='version__releases__deployment__log__source__remote__command-icon' toolTipText={params?.value ?? 'Remote Command'} />
                }
            }
        },
        {
            field: 'requestedOn',
            headerName: 'Requested On',
            flex: 1,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 500 }}>{formatRelativeTimeForTable(params.value)}</span>
            )
        }
    ]


    useEffect(() => {
        deploymentLogTablePropsRef.current = deploymentLogTableProps
    }, [deploymentLogTableProps])

    useEffect(() => {
        deploymentLogsRef.current = deploymentLogs;
    }, [deploymentLogs])

    const layoutCallback = useCallback(
        async (
            pageNumber: number,
            pageSize: number,
            view: string,
            field: string | null,
            order: string,
            filterData,
            searchTerm: string,
        ) => {
            const tableProps = cloneDeep(deploymentLogTablePropsRef?.current);
            const deploymentLogsFilter = getCurrentFiltersValues('softwareVersionDeploymentLogs');
            const appliedFilters = filterData ? filterData : deploymentLogsFilter;

            await dispatch(
                fetchDeploymentLogsListData({
                    view: view ?? 'list',
                    sortBy: field || tableProps?.sortBy,
                    order: order || tableProps?.order,
                    pageSize: pageSize,
                    pageNumber: pageNumber,
                    filters: appliedFilters,
                    searchTerm: searchTerm != null ? searchTerm : tableProps?.searchTerm,
                })
            );

            if (tableProps) {
                tableProps.view = view || 'list'
                tableProps.sortBy = field || deploymentLogTablePropsRef?.current?.sortBy;
                tableProps.order = order || deploymentLogTablePropsRef?.current?.order;
                tableProps.pageNumber = pageNumber;
                tableProps.pageSize = pageSize;
                if (searchTerm != null && searchTerm != undefined) {
                    tableProps.searchTerm = searchTerm;
                }
            }
            await dispatch(setDeploymentLogsTableProps(tableProps));
        },
        [deploymentLogTablePropsRef?.current, dispatch]
    );

    //This function is use to handle the change of search text in the search box
    //It will update the table props with the new search text and call the layoutCallback to
    //fetch the data based on the new search text and other parameters.
    //It uses useCallback to memoize the function and avoid unnecessary re-renders.
    //It also uses cloneDeep to create a deep copy of the versionReleaseTablePropsRef
    //to avoid mutating the original object.
    //The function is dependent on the versionReleaseTablePropsRef and layoutCallback.
    const onChangeOfSearchText = useCallback(async (searchText: string) => {
        const trimmedSearchText = searchText.trim();
        const tableProps = cloneDeep(deploymentLogTablePropsRef?.current);
        if (tableProps) {
            tableProps.searchTerm = trimmedSearchText;
        }
        const versionReleaseFilter = getCurrentFiltersValues('softwareVersionDeploymentLogs');
        await layoutCallback(
            1,
            tableProps?.pageSize,
            tableProps?.view,
            tableProps?.sortBy,
            tableProps?.order,
            versionReleaseFilter,
            trimmedSearchText,
        )
    }, [deploymentLogsRef?.current, deploymentLogTablePropsRef?.current, layoutCallback]);

    const searchBoxConfiguration = useMemo(() => {
        return {
            searchBoxClassName: 'deployment-logs__search__box',
            searchFieldId: 'deployment-logs-search-box',
            searchFieldName: 'deployment-logs-search-box',
            handleSearch: onChangeOfSearchText,
        };
    }, [onChangeOfSearchText, deploymentLogTablePropsRef?.current]);


    //These are the functions to handle the export button click and close the export dropdown menu
    const handleClose = (): void => {
        setExportAnchorEl(null);

    };

    const fileDownloadSuccessToast = useCallback((): Id => {
        setExportingFile(false);
        return toast.success('File downloaded.');
    }, []);

    const fileDownloadFailureToast = useCallback((): Id => {
        setExportingFile(false);
        return toast.warn('Something went wrong. Please export again.');
    }, []);

    const onExportBtnClick = useCallback(async (fileType: 'csv' | 'xlsx'): Promise<void> => {
        if (exportingFile) {
            // already exporting a file, do not allow another export
            return;
        }
        try {
            const response = await dispatch(exportVersionReleaseListData({ fileType, filters: getCurrentFiltersValues('versionReleases', true) }));
            if (response?.status === 200 || response?.status === 202) {
                downloadFile({ url: response?.data?.url });
                fileDownloadSuccessToast();
            } else {
                fileDownloadFailureToast();
                setExportAnchorEl(null);
            }
        } finally {
            setExportingFile(false);
            setExportAnchorEl(null);
        }
    }, [exportingFile, fileDownloadSuccessToast, fileDownloadFailureToast]);


    //These are the header action buttons that will be rendered in the header of the software version releases page

    const headerActionBtns = renderHeaderActionButtons({
        actionBtns:
            [
                {
                    id: 'add_filter_btn',
                    isAccessible: true,
                    headerActionBtnClick: (): void => {
                        setFiltersVisible(true);
                    },
                    badgeCount: getCurrentScreenAppliedFiltersCount('softwareVersionDeploymentLogs')
                },
                // {
                //   id: 'export_csv_btn',
                //   isAccessible: true,
                //   // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                //   headerActionBtnClick: (event): void => {
                //     setExportAnchorEl(event.currentTarget);
                //   },
                // },
            ],
    })


    const handleFiltersClosePopOver = (): void => {
        setFiltersVisible(false);
    }

    const onResetButtonClick = useCallback(async (callList: boolean) => {
        const res = await setFilterData(null, '', 'softwareVersionDeploymentLogs', 'CLEAR', true)(dispatch);
        if (res?.message === 'Action dispatched successfully') {
            // Reset the filters
            if (callList && deploymentLogTablePropsRef?.current) {
                const tableProps = cloneDeep(deploymentLogTablePropsRef?.current);
                await layoutCallback(
                    1,
                    tableProps?.pageSize,
                    tableProps?.view,
                    tableProps?.sortBy,
                    tableProps?.order,
                    res?.filters,
                    tableProps?.searchTerm ?? '',
                )
            }
        }

    }, [deploymentLogTablePropsRef?.current,deploymentLogsFiltersAppliedFromRedirection])

    const filterFooterBtns = useMemo(() => {
        return [
            {
                buttonText: 'Reset',
                buttonId: 'Reset',
                btnClassName: 'secondary__btn',
                handleClick: (): Promise<void> => onResetButtonClick(true),
                isDisabled: false,
                buttonVariant: 'outlined',
            },
        ];
    }, [onResetButtonClick]);

    const handleFilterDataChange = useCallback(async (data, filterKey: string, isGlobal: boolean) => {
        const tableProps = cloneDeep(deploymentLogTablePropsRef?.current);
        const res = await setFilterData(data, filterKey, 'softwareVersionDeploymentLogs', 'SET', isGlobal)(dispatch);
        if (res?.message === 'Action dispatched successfully') {
            await layoutCallback?.(
                1,
                tableProps?.pageSize,
                tableProps?.view,
                tableProps?.sortBy,
                tableProps?.order,
                res?.filters,
                tableProps?.searchTerm ?? '',
            )
        }
    }, [deploymentLogTablePropsRef?.current, deploymentLogsRef?.current]);



    const deploymentLogsFilterProps: FilterProp[] = useMemo(() => {
        const filterRequestedOnDateValue = getFilterSelectedValue('swVersionRequestedOnInterval', 'softwareVersionDeploymentLogs', false);
        return [
            {
                filterLabel: 'Charging Station',
                filterId: 'chargingStationId',
                filterType: 'dropdown',
                filterDropdownProps: {
                    selectValue: getFilterSelectedValue('chargingStationId', 'softwareVersionDeploymentLogs', false),
                    selectOptions: chargingStationReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handleFilterDataChange(val, 'chargingStationId', false)
                    },
                    selectDropDownId: 'deployment-logs-charging-station-filter-dropdown',
                    isMultiSelect: true
                }
            },
            {
                filterLabel: 'Product Type',
                filterId: 'productType',
                filterType: 'dropdown',
                filterDropdownProps: {
                    selectValue: getFilterSelectedValue('productType', 'softwareVersionDeploymentLogs', false),
                    selectOptions: chargerProductTypeReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handleFilterDataChange(val, 'productType', false)
                    },
                    selectDropDownId: 'deployment-logs-product-type-filter-dropdown',
                    isMultiSelect: true
                }
            },
            {
                filterLabel: 'SW Type',
                filterId: 'versionLogSwType',
                filterType: 'dropdown',
                filterDropdownProps: {
                    selectValue: getFilterSelectedValue('versionLogSwType', 'softwareVersionDeploymentLogs', false),
                    selectOptions: versionReleasesSwTypeReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handleFilterDataChange(val, 'versionLogSwType', false)
                    },
                    selectDropDownId: 'deployment-logs-sw-type-filter-dropdown',
                    isMultiSelect: true
                }
            },
            {
                filterLabel: 'Software Version',
                filterId: 'swVersionUpdateLogs',
                filterType: 'dropdown',
                filterDropdownProps: {
                    selectValue: getFilterSelectedValue('swVersionUpdateLogs', 'softwareVersionDeploymentLogs', false),
                    selectOptions: softwareVersionReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handleFilterDataChange(val, 'swVersionUpdateLogs', false)
                    },
                    selectDropDownId: 'deployment-logs-software-version-filter-dropdown',
                    isMultiSelect: true
                }
            },
            {
                filterLabel: 'Status',
                filterId: 'swLogStatus',
                filterType: 'dropdown',
                filterDropdownProps: {
                    selectValue: getFilterSelectedValue('swLogStatus', 'softwareVersionDeploymentLogs', false),
                    selectOptions: statusReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handleFilterDataChange(val, 'swLogStatus', false)
                    },
                    selectDropDownId: 'deployment-logs-status-filter-dropdown',
                    isMultiSelect: true
                }
            },
            {
                filterLabel: 'Requested On',
                filterId: 'swVersionRequestedOnInterval',
                filterType: 'dateFilter',
                dateFilterProps: {
                    datePickerId: 'deployment-logs-requestedOn-date-picker',
                    datePickerClassName: '',
                    selectsRange: true,
                    startDate: filterRequestedOnDateValue?.[0]
                        ? new Date(filterRequestedOnDateValue?.[0])
                        : null,
                    endDate: filterRequestedOnDateValue?.[1]
                        ? new Date(filterRequestedOnDateValue?.[1])
                        : null,
                    onChange: (val): void => {
                        handleFilterDataChange(val, 'swVersionRequestedOnInterval', false);
                    },
                }
            }
        ]
    }, [chargerProductTypeReferenceData, chargingStationReferenceData,softwareVersionReferenceData ,handleFilterDataChange, screenFilters,versionReleasesSwTypeReferenceData]);

    const getTableRows = useCallback((): IDeploymentLog[] => {
        return deploymentLogs !== null && deploymentLogs?.length > 0 ? deploymentLogs : []
    }, [deploymentLogs])


    //Clearing the redux states
    const deploymentLogsListCleanUpState = useCallback(() => {
        const action = {
            type: versionReleasesTypes.CLEAR_DEPLOYMENT_LOGS_DATA,
        }
        dispatch(action)
        if (deploymentLogsFiltersAppliedFromRedirection) {
            onResetButtonClick(true)
        }
        setRedirectedStateForDeploymentLogsFilters(false)(dispatch)
    }, [deploymentLogsFiltersAppliedFromRedirection])

    useEffect(() => {
        window.addEventListener('beforeunload', deploymentLogsListCleanUpState);
        return (): void => {
            deploymentLogsListCleanUpState()
            window.removeEventListener('beforeunload', deploymentLogsListCleanUpState)
        }
    }, [])

    const updateFiltersFromRedirection = useCallback(async()=>{
        await setFilterData(null, '', 'softwareVersionDeploymentLogs', 'CLEAR', true)(dispatch);
        let res ;
        if(location?.state?.productType){
            const productType = chargerProductTypeReferenceData?.filter(item=>item.name ===location?.state?.productType )
            res = await setFilterData(productType, 'productType', 'softwareVersionDeploymentLogs', 'SET', false)(dispatch);
        }
        if(location?.state?.softwareVersion){
            const  swVersionUpdateLogs = softwareVersionReferenceData?.filter(item=>item.name ===location?.state?.softwareVersion )
            res = await setFilterData( swVersionUpdateLogs, 'swVersionUpdateLogs', 'softwareVersionDeploymentLogs', 'SET', false)(dispatch);
        }

        if(location?.state?.swLogStatus){
            const  swLogStatus = statusReferenceData?.filter(item=>item.name ===location?.state?.swLogStatus )
            res = await setFilterData( swLogStatus, 'swLogStatus', 'softwareVersionDeploymentLogs', 'SET', false)(dispatch);
        }
        if(location?.state?.customer){
            await setFilterData(location?.state?.customer, 'customer', 'chargers', 'SET', true)(dispatch)
        }
         const tableProps = cloneDeep(deploymentLogTablePropsRef?.current);
        if (res?.message === 'Action dispatched successfully') {
            await layoutCallback?.(
                1,
                tableProps?.pageSize,
                tableProps?.view,
                tableProps?.sortBy,
                tableProps?.order,
                res?.filters,
                tableProps?.searchTerm ?? '',
            )
        }
    },[deploymentLogTablePropsRef?.current,chargerProductTypeReferenceData,softwareVersionReferenceData,statusReferenceData,location?.state])
    useEffect(()=>{
        if(location?.state){
            updateFiltersFromRedirection()
        }
    },[location?.state])
    return (
        <>
            <TableDashboard
                layoutsEnabled={true}
                tableId="manage-deployment-logs-table"
                tableClassName="manage__deployment__logs__table"
                header='Deployment Log (History)'
                searchBoxIncluded={true}
                searchBoxConfiguration={searchBoxConfiguration}
                gridColumns={deploymentLogsTableColumns}
                tableRows={getTableRows()}
                layoutView='list'
                headerActionBtns={headerActionBtns}
                listLayoutCallBack={layoutCallback}
                totalCount={deploymentLogTableListLoader ? 0 : deploymentLogsCount}
                showSkeleton={!deploymentLogs}
                totalCountText={'Deployment Logs'}
                showLoader={deploymentLogTableListLoader}
                pageNumber={deploymentLogTableProps?.pageNumber}
                tablePageSize={deploymentLogTableProps?.pageSize}
                sortField={deploymentLogTableProps?.sortBy}
                sortOrder={deploymentLogTableProps?.order}
                showRefreshButton={false}
                leftPinnedColumns={['chargerName']}
            />

            <Menu
                id="export-option-dropdown"
                anchorEl={exportAnchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                className='export__option__dropdown'
                sx={{ top: '30px' }}
                open={Boolean(exportAnchorEl)}
                onClose={handleClose}
            >
                <MenuItem>
                    <div className='export__btn-option' onClick={(e) => { e?.stopPropagation(); onExportBtnClick('csv') }}>
                        To CSV
                    </div>
                </MenuItem>
                <MenuItem>

                    <div className='export__btn-option' onClick={(e) => {
                        e?.stopPropagation();
                        onExportBtnClick('xlsx')
                    }}>
                        To Excel
                    </div>
                </MenuItem>
            </Menu>

            {/* This is filter pop over */}
            <>
                {
                    filtersVisible && <SidePopover
                        id={'manage-deployment-logs-filters'}
                        open={filtersVisible}
                        containerClassName={'deployment-logs-side-filters'}
                        handleClose={handleFiltersClosePopOver}
                        headerText={'Add Filters'}
                        // eslint-disable-next-line react/no-children-prop
                        children={<FilterLayout requiredReferenceDataCallbacks={['productType', 'chargingStationId', 'customer', 'softwareVersion','versionSwType']}
                            filters={deploymentLogsFilterProps} handleFilterDataChange={handleFilterDataChange}
                            excludeGlobalFilters={false}
                        />}
                        btnsList={filterFooterBtns}
                    />
                }
            </>
        </>
    )
}

export default ManageDeploymentLogsDashboard;